import React from 'react'
import { isEmpty } from 'lodash'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const CategoriesHeadband = ({
  data,
  action,
}) => {
  return (
    <React.Fragment>
      <div style={{ backgroundColor: '#ffffff', overflow: 'auto', whiteSpace: 'nowrap', height: '90px' }}>
        {!isEmpty(data) && data.map((item, key) => (
          <div
            key={`${item.id}-${key}`}
            style={{ display: 'inline-block' }}
            className="text-center cursor-pointer"
            onClick={() => action(item)}
          >
            <img
              className="avatar-sm img-center"
              src={!isEmpty(item.image) ? `https://storage.googleapis.com/vendora-storage/categories/${item.image}` : getUrlOfDefaultProductImage()}
              alt=""
              style={{ objectFit: 'contain' }}
            />
            <div style={{ width: '70px' }}>
              <label style={{ fontSize: '9px', overflow: 'hidden', textOverflow: 'ellipsis', width: '65px' }}>{item.name}</label>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

export default CategoriesHeadband
